import heic2any from 'heic2any';

const isHeicFile = (file) => {
  const type = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();

  return (
    type === 'image/heic' ||
    type === 'image/heif' ||
    name.endsWith('.heic') ||
    name.endsWith('.heif')
  );
};

export const getFileExtension = (file) => {
  const subtype = (file.type || '').split('/')[1];
  if (subtype) return subtype.split('+')[0].split(';')[0].toLowerCase();

  const fileParts = (file.name || '').split('.');
  return fileParts.length > 1
    ? fileParts[fileParts.length - 1].toLowerCase()
    : '';
};

export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const convertHeicIfNeeded = async (file, transparent) => {
  if (!isHeicFile(file)) return file;

  const converted = await heic2any({
    blob: file,
    toType: transparent ? 'image/png' : 'image/jpeg',
    quality: 0.9,
  });

  const blob = Array.isArray(converted) ? converted[0] : converted;

  const fileName = file.name.replace(
    /\.(heic|heif)$/i,
    transparent ? '.png' : '.jpg',
  );

  return new File([blob], fileName, {
    type: blob.type,
  });
};
